import req from './http.js'

// 訂閱功能列表
export const apiGetSubscriptionTree = () => req(
    'get',
    `/view/subscription/tree`,
    null
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})